import script from "./AnnotationControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnotationControls.vue?vue&type=script&setup=true&lang=ts"

import "./AnnotationControls.vue?vue&type=style&index=0&id=5996f916&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5996f916"]])

export default __exports__